import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { JsonLdBuilder } from '../../structured-data.model';
import { BoelsPointOfService } from '@boels/models';
import { SiteContextFacade } from '@boels/shared-state';
import { map } from 'rxjs/operators';

@Injectable()
export class JsonldLocalBusinessBranchBuilder
  implements JsonLdBuilder<BoelsPointOfService>
{
  private siteContextFacade = inject(SiteContextFacade);

  build(pointOfService: BoelsPointOfService): Observable<any> {
    return this.siteContextFacade.getActiveBaseSiteEntity().pipe(
      map((baseSite) => ({
        branchOf: {
          '@type': 'Organization',
          url: `www.boels.com/branches/${pointOfService.name}`,
          name: baseSite?.sdName,
        },
      })),
    );
  }
}
